import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'allLettersCapital',
  standalone: true,
})
export class AllLettersCapitalPipe implements PipeTransform {
  transform(value: string = '', ignoreAbbreviation: boolean = false): string {
    if (value == null || value === ' ') {
      return '-';
    }

    return value
      .split(' ')
      .map((word) => {
        // Capitalize words separated by '/', ',', '-', '(', and ')'
        return this.capitalizeWordWithSeparators(
          word,
          ['/', ',', '-', '(', ')'],
          ignoreAbbreviation
        );
      })
      .join(' ');
  }

  private capitalizeWordWithSeparators(
    word: string,
    separators: string[],
    ignoreAbbreviation: boolean
  ): string {
    // Use a simpler approach - replace separators with a unique placeholder, split, then restore
    let result = word;
    const placeholder = '|||SEPARATOR|||';

    // Replace all separators with placeholder
    for (const separator of separators) {
      result = result
        .split(separator)
        .join(`${placeholder}${separator}${placeholder}`);
    }

    // Split by placeholder and process each part
    const parts = result.split(placeholder);

    return parts
      .map((part) => {
        // Skip separators
        if (separators.includes(part)) {
          return part;
        }

        if (!part) return part;

        // Leave abbreviations as they are (only if they're all uppercase AND more than 1 character)
        if (
          part === part.toUpperCase() &&
          part.length > 1 &&
          !ignoreAbbreviation
        ) {
          return part;
        } else {
          // Always ensure first letter is uppercase and rest are lowercase
          return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
        }
      })
      .join('');
  }
}
